export default __webpack_public_path__ + "static/media/travel.d6a46b58.png";